import React, { useEffect, useRef, useState } from "react";
import cert1 from "../assets/img/cert-img1.png";
import cert2 from "../assets/img/cert-img2.png";
import cert3 from "../assets/img/cert-img3.png";
import cert4 from "../assets/img/cert-img4.png";
import cert5 from "../assets/img/cert-img5.png";
import cert6 from "../assets/img/cert-img6.png";
import cert7 from "../assets/img/cert-img7.png";
import cert8 from "../assets/img/cert-img8.png";
import cert9 from "../assets/img/cert-img9.png";
import cert10 from "../assets/img/cert-img10.png";


const items = [cert1, cert2, cert3, cert4, cert5, cert6, cert7, cert8, cert9, cert10];

const CertificateSlider = ({ images = items, autoPlay = true, interval = 2000 }) => {
    const [current, setCurrent] = useState(0);
    const [animDirection, setAnimDirection] = useState("");
    const intervalRef = useRef(null);

    const nextSlide = () => {
        setAnimDirection("next");
        setCurrent((prev) => (prev + 1) % images.length);
    };

    const prevSlide = () => {
        setAnimDirection("prev");
        setCurrent((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const switchImage = (index) => {
        if (index === current) return;
        setAnimDirection(index > current ? "next" : "prev");
        setCurrent(index);
    };

    const startAutoSlide = () => {
        stopAutoSlide();
        if (autoPlay) intervalRef.current = setInterval(nextSlide, interval);
    };

    const stopAutoSlide = () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
    };

    useEffect(() => {
        startAutoSlide();
        return () => stopAutoSlide();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="slide-container" onMouseOver={stopAutoSlide} onMouseOut={startAutoSlide}>
            <div className="slides">
                {images.map((src, index) => (
                    <img
                        key={index}
                        src={src}
                        alt={`certificate-${index + 1}`}
                        className={`${index === current ? "active" : ""} ${animDirection}`}
                    />
                ))}
            </div>

            <div className="buttons">
                <span className="prev" onClick={prevSlide} aria-label="Previous">&#10094;</span>
                <span className="next" onClick={nextSlide} aria-label="Next">&#10095;</span>
            </div>

            <div className="dotsContainer">
                {images.map((_, index) => (
                    <div
                        key={index}
                        className={`dot ${index === current ? "active" : ""}`}
                        onClick={() => switchImage(index)}
                        role="button"
                        aria-label={`Go to ${index + 1}`}
                        tabIndex={0}
                    />
                ))}
            </div>
        </div>
    );
};

export default CertificateSlider;
